/* eslint-enable */

class AnimationHeroSingleInsight {
    constructor(args = { sectionsContainer: document }) {
        this.sectionsContainer = args.sectionsContainer;
        this.$moduleHeroInsight = this.sectionsContainer.querySelector('.hero-insights');
        
        if (!this.$moduleHeroInsight) return;
        
        this.$moduleHeroInsightElements = this.$moduleHeroInsight.querySelectorAll('.anima');
        
        this.init();
    }

    init() {
        this.setAnimation();
    }

    setAnimation() {
        gsap.set(this.$moduleHeroInsight, { opacity: 1 }); // Mejor usar opacity 0
        gsap.set(this.$moduleHeroInsightElements, { yPercent: 100, opacity: 0, onComplete: () => this.initAnimate() });
    }

    initAnimate() {
        this.animateHeroInsight = gsap.timeline({
            defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleHeroInsight,
                //start: 'top bottom', // Ajusta esto según lo que necesites
                toggleActions: 'play none none none'
            },
            onComplete: () => {
                gsap.set(this.$moduleHeroInsightElements, { clearProps: true });
            }
        });
    
        this.animateHeroInsight.addLabel('step1');
        this.animateHeroInsight.to(this.$moduleHeroInsight, { opacity: 1, duration: 1 }, 'step1');
        this.animateHeroInsight.to(this.$moduleHeroInsightElements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
    }
}

export default AnimationHeroSingleInsight;
